import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MaskPipe } from 'ngx-mask';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-dashboard-drafts-variables-list',
  templateUrl: './dashboard-drafts-variables-list.component.html',
  styleUrls: ['./dashboard-drafts-variables-list.component.scss'],
})
export class DashboardDraftsVariablesListComponent implements OnInit {
  permissionObj = {
    canEdit: true,
    canView: true,
    canChange: true,
    canFilter: true,
  };

  models: any[] = [];

  exempleForm = this.formBuilder.group({
    content: [null, []],
  });

  filterForm = this.formBuilder.group({
    search: [null, []],
    status: [null, []],
  });

  fsFilterForm = this.formBuilder.group({
    search: [null, []],
    status: [null, []],
  });

  statusOptions: SelectItem[] = [
    { label: 'Ativo', value: 'true' },
    { label: 'Inativo', value: 'false' },
  ];

  activedTab = 'cadastro';

  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ]
  };

  canViewDraft = false;

  loading = true;
  /**
   * Padrão de Filtros:
   * - hasFilters só deve ser true APÓS aplicar os filtros (método filterData())
   * - NÃO atualizar hasFilters no valueChanges do filterForm
   * - hasFilters deve ser atualizado apenas quando:
   *   1. filterData() executar com sucesso (após a requisição)
   *   2. resetForm() for chamado (define como false)
   *   3. toggleFilterModal() quando há filtros salvos no storage
   * - Cada tab (cadastro/fundo) tem seus próprios filtros
   */
  hasFilters = false;
  appliedFilters: Array<{ label: string; value: string }> = [];
  showFilterModal = false;

  offset: number = 0;
  resultsPerPage = 50;
  count: number = 0;
  data: VariableValues[] = [];

  fsOffset: number = 0;
  fsResultsPerPage = 50;
  fsCount: number = 0;
  fsData: VariableValues[] = [];

  exampleModal = false;
  tabIndex = 0;
  warningModal = false;
  variableLabel: string = '';
  selectedVariable: VariableValues | null = null;

  modelsCount: number = 0;
  modelsOffset: number = 0;
  modelsResultsPerPage: number = 50;
  modelsLoading = true;

  tabs = [
    { label: 'Cadastro', value: 'cadastro' },
    { label: 'SMART', value: 'fundo' },
  ];

  exempleVariables = [
    { label: '<$CEDENTECPF>', value: '123.456.789-00', type: 'data_engine' },
    {
      label: '<$CEDENTECNPJ>',
      value: '12.345.678/0001-90',
      type: 'data_engine',
    },
    {
      label: '<$CEDENTECELULAR>',
      value: '(11) 99999-8888',
      type: 'data_engine',
    },
    { label: '<$CEDENTECNAE>', value: '6421-2/00', type: 'data_engine' },
    {
      label: '<$FUNDONOME>',
      value: 'Fundo de Investimento XYZ',
      type: 'fs_engine',
    },
    { label: '<$FUNDOSIGLA>', value: 'FI-XYZ', type: 'fs_engine' },
    {
      label: '<$FUNDONUMERODOCUMENTO>',
      value: '98.765.432/0001-10',
      type: 'fs_engine',
    },
    {
      label: '<$CEDENTEEMAIL>',
      value: 'contato@empresa.com.br',
      type: 'data_engine',
    },
    {
      label: '<$CEDENTEDOCUMENTO>',
      value: '123.456.789-00',
      type: 'data_engine',
    },
    { label: '<$CEDENTECEP>', value: '01310-100', type: 'data_engine' },
    { label: '<$CEDENTEBAIRRO>', value: 'Centro', type: 'data_engine' },
    { label: '<$CEDENTECIDADE>', value: 'São Paulo', type: 'data_engine' },
    { label: '<$CEDENTECOMPLEMENTO>', value: 'Sala 1001', type: 'data_engine' },
    { label: '<$CEDENTEESTADO>', value: 'SP', type: 'data_engine' },
    {
      label: '<$CEDENTELOGRADOURO>',
      value: 'Avenida Paulista',
      type: 'data_engine',
    },
    { label: '<$CEDENTENUMERO>', value: '1578', type: 'data_engine' },
    { label: '<$CEDENTEPAIS>', value: 'Brasil', type: 'data_engine' },
    {
      label: '<$CEDENTEESTADOCIVIL>',
      value: 'Solteiro(a)',
      type: 'data_engine',
    },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    private toast: ToastService,
    public signupService: SignupService,
    private router: Router,
    private authService: AuthService,
    private maskPipe: MaskPipe,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.authService.canViewPage(['de_can_view_variables']);
    this.canViewDraft = this.authService.verifyPermission('de_can_view_drafts');

    this.setPermissions();
    this.setBreadcrumb();
    this.getData('fundo');
    this.getData('cadastro');

    this.exempleForm.controls.content.valueChanges.subscribe((value) => {
      this.formatContent(value);
    });
  }

  onChangeTab(index: number) {
    // Limpar filtros ao trocar de aba
    this.hasFilters = false;
    this.appliedFilters = [];

    if (this.activedTab === 'fundo') {
      this.fsFilterForm.reset();
    } else {
      this.filterForm.reset();
    }

    this.activedTab = this.tabs[index].value;
    this.tabIndex = index;

    // Recarregar dados sem filtros para a nova aba
    this.getData(this.activedTab);
  }

  async getData(type: string, page: number = 1) {
    this.loading = true;
    try {
      const filters: any = {};

      // Construir filtros a partir do formulário correspondente (se houver valores)
      const form = type === 'fundo' ? this.fsFilterForm : this.filterForm;
      const values = form.value;

      Object.entries(values).forEach(([key, value]: any) => {
        if (value !== null && value !== '') {
          // Verificar se o campo tem erro de validação antes de incluir
          const control = form.get(key);
          if (control && control.valid) {
            filters[key] = value;
          }
        }
      });

      // Atualizar hasFilters e tags apenas se for a tab ativa
      if (type === this.activedTab) {
        this.hasFilters = Object.keys(filters).length > 0;
        if (this.hasFilters) {
          this.generateFilterTags(values, type);
        } else {
          this.appliedFilters = [];
        }
      }

      const { count, results, offset, results_per_page } = await this.api.get({
        route: 'api/variables/',
        token: true,
        params: { page, type, ...filters },
      });

      if (type === 'fundo') {
        this.fsCount = count;
        this.fsData = results;
        this.fsOffset = offset;
        this.fsResultsPerPage = results_per_page ?? 50;
      } else {
        this.offset = offset;
        this.count = count;
        this.data = results;
        this.resultsPerPage = results_per_page ?? 50;
      }
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.loading = false;
  }

  addDraft() {
    this.router.navigateByUrl('/app/drafts/types/new');
  }

  async handleToggleStatus(id: number) {
    this.selectedVariable = this.data.find((item) => item.id === id);
    if (this.selectedVariable.status) {
      this.warningModal = true;

      this.selectedVariable = this.data.find((item) => item.id === id);
      this.variableLabel = this.selectedVariable.name;
      this.getModelsData(this.selectedVariable.variable);
    } else {
      this.changeVariableStatus(id);
    }
  }
  async changeVariableStatus(id: number) {
    this.loading = true;
    try {
      await this.api.patch({
        route: `api/variables/${id}/`,
        token: true,
        body: {
          status: !this.selectedVariable.status,
        },
      });

      this.closeWarningModal();
      this.getData(this.activedTab);
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.loading = false;
  }

  async getModelsData(variable: string, page: number = 1) {
    this.modelsLoading = true;
    try {
      const { count, results, offset, results_per_page } = await this.api.get({
        route: 'api/checking_variables/',
        token: true,
        params: { page, variable: '<$CEDENTENIRE>' },
      });

      this.modelsCount = count;
      this.models = results ? results.documents : [];
      this.modelsOffset = offset;
      this.modelsResultsPerPage = results_per_page ?? 50;
    } catch (error) {
      console.error(error);
    }
    this.modelsLoading = false;
  }

  changePageData(type, page: number) {
    this.loading = true;
    this.getData(type, page);
  }

  changeModelsPageData(page: number) {
    this.modelsLoading = true;
    this.getModelsData(this.selectedVariable.variable, page);
  }

  generateFilterTags(formValues: any, type: string) {
    this.appliedFilters = [];

    const fieldLabels: { [key: string]: string } = {
      search: 'Nome',
      status: 'Status',
    };

    Object.entries(formValues).forEach(([key, value]: any) => {
      if (value !== null && value !== '' && value !== undefined) {
        let displayValue = value;

        // Tratamento especial para status
        if (key === 'status') {
          const statusOption = this.statusOptions.find(
            (s) => s.value === value
          );
          displayValue = statusOption ? statusOption.label : value;
        }

        if (fieldLabels[key]) {
          // Combinar label e valor no formato "label: valor"
          const combinedLabel = `${fieldLabels[key]}: ${String(displayValue)}`;
          this.appliedFilters.push({
            label: combinedLabel,
            value: String(displayValue),
          });
        }
      }
    });
  }

  toggleFilterModal() {
    this.showFilterModal = !this.showFilterModal;

    if (this.showFilterModal) {
      // Se houver filtros aplicados, restaurar no formulário
      if (this.hasFilters && this.appliedFilters.length > 0) {
        // Os valores já estão no formulário, apenas garantir que as tags estão atualizadas
        const formValues =
          this.activedTab === 'fundo'
            ? this.fsFilterForm.value
            : this.filterForm.value;
        this.generateFilterTags(formValues, this.activedTab);
      } else {
        this.hasFilters = false;
        this.appliedFilters = [];
      }
    }
  }

  resetForm() {
    this.hasFilters = false;
    this.appliedFilters = [];

    if (this.activedTab === 'fundo') {
      this.fsFilterForm.reset();
    } else {
      this.filterForm.reset();
    }
    this.showFilterModal = false;
    this.loading = true;

    this.getData(this.activedTab);
  }

  async filterData(type: string) {
    // Verificar se o formulário é válido antes de processar
    const form = type === 'fundo' ? this.fsFilterForm : this.filterForm;

    if (form.invalid) {
      // Marcar todos os campos como touched para mostrar erros
      Object.keys(form.controls).forEach((key) => {
        form.get(key)?.markAsTouched();
      });
      return;
    }

    this.loading = true;

    try {
      const values = form.value;

      const filters: any = {};

      Object.entries(values).forEach(([key, value]: any) => {
        if (value !== null && value !== '') {
          // Verificar se o campo tem erro de validação antes de incluir
          const control = form.get(key);
          if (control && control.valid) {
            filters[key] = value;
          }
        }
      });

      const { count, results, offset, results_per_page } = await this.api.get({
        route: 'api/variables/',
        token: true,
        params: { page: 1, type, ...filters },
      });

      // ✅ IMPORTANTE: hasFilters só é atualizado após aplicar os filtros com sucesso
      // Apenas atualizar se for a tab ativa
      if (type === this.activedTab) {
        this.hasFilters = Object.keys(filters).length > 0;

        // ✅ Gerar as tags dos filtros aplicados apenas para a tab ativa
        this.generateFilterTags(values, type);
      }

      if (type === 'fundo') {
        this.fsCount = count;
        this.fsData = results;
        this.fsOffset = offset;
        this.fsResultsPerPage = results_per_page ?? 50;
      } else {
        this.offset = offset;
        this.count = count;
        this.data = results;
        this.resultsPerPage = results_per_page ?? 50;
      }
      this.showFilterModal = false;
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
    this.loading = false;
  }

  closeWarningModal() {
    this.warningModal = false;
    this.exampleModal = false;
    this.selectedVariable = null;
    this.variableLabel = '';

    this.exempleForm.controls.content.setValue('', { emitEvent: false });
  }

  setPermissions() {
    const permissions = Object.keys(this.permissionObj).map(
      (key) => `de_can_${key.split('can').join('').toLowerCase()}_variables`
    );

    permissions.forEach((permission, idx) => {
      this.permissionObj[Object.keys(this.permissionObj)[idx]] =
        this.authService.verifyPermission(permission);
    });
  }

  setBreadcrumb(): void {
    const canViewDrafts =
      this.authService.verifyPermission('de_can_view_drafts');
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Minutas',
        url: '/app/drafts',
        clickable: canViewDrafts,
      },
      {
        label: 'Variáveis',
        url: '/app/drafts/variables',
        clickable: false, // Página atual, não precisa ser clicável
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }

  joinFunds(fund: any[]) {
    return fund
      .map(
        (fund) =>
          `${this.maskPipe.transform(
            fund.fund_document,
            '00.000.000/0000-00'
          )} | ${fund.fund_name}`
      )
      .join(', ');
  }

  redirectToModel(id: number) {
    this.router.navigateByUrl(`/app/drafts/models/${id}`);
  }

  formatContent(value: string) {
    if (!value) return;

    let formattedContent = value;
    let hasChanges = false;

    this.exempleVariables.forEach((variable) => {
      const htmlEncodedLabel = variable.label
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

      const baseStyle =
        'color: #9f1853; width: fit-content; padding: 5px 12px; border-radius: 20px; background: #ffd6e8; display: inline-block; margin: 0 2px;';
      const smartStyle =
        'color: #0043ce; width: fit-content; padding: 5px 12px; border-radius: 20px; background: #d0e2ff; display: inline-block; margin: 0 2px;';

      const style = variable.type === 'fs_engine' ? smartStyle : baseStyle;

      const spanWithStyle = `<span style="${style}">${variable.value}</span>&nbsp;`;

      const originalRegex = new RegExp(this.escapeRegex(variable.label), 'g');
      const htmlRegex = new RegExp(this.escapeRegex(htmlEncodedLabel), 'g');

      const beforeReplace = formattedContent;
      formattedContent = formattedContent.replace(originalRegex, spanWithStyle);
      formattedContent = formattedContent.replace(htmlRegex, spanWithStyle);

      if (beforeReplace !== formattedContent) {
        hasChanges = true;
      }
    });

    if (hasChanges) {
      this.exempleForm.controls.content.setValue(formattedContent, {
        emitEvent: false,
      });
    }
  }

  private escapeRegex(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  insertVariable(label: string) {
    const currentContent = this.exempleForm.controls.content.value || '';
    this.exempleForm.controls.content.setValue(currentContent + label);
  }

  /**
   * Verifica se os filtros podem ser aplicados
   * Retorna false se houver campos inválidos ou se não houver nenhum filtro preenchido
   */
  get canApplyFilters(): boolean {
    // Verifica qual formulário usar baseado na tab ativa
    const form =
      this.activedTab === 'fundo' ? this.fsFilterForm : this.filterForm;

    // Verifica se o formulário é válido
    if (form.invalid) {
      return false;
    }

    // Verifica se há pelo menos um filtro preenchido
    const values = form.value;
    const hasAnyFilter = Object.values(values).some(
      (value) => value !== null && value !== '' && value !== undefined
    );

    return hasAnyFilter;
  }
}
